import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getModuleSidebarNavCohortListApi } from 'api/views';
import { useSelector } from 'react-redux';
import { selectEnabledFeatureFlags } from 'selectors/enabledFeatureFlags';

import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { SIDEBAR_ICONS_FOR_NAMES, SIDEBAR_ICONS_FOR_TYPES } from 'services/sidebarNav/sidebarNav';

export const getModuleSidebarNavCohorts = ({ moduleType }) => {
  const apiFunction = getModuleSidebarNavCohortListApi;
  return apiFunction({ moduleType }).then((res) => {
    const { cohortList, defaultList } = res?.entity ?? {};
    const defaultListWithIcons = defaultList.map((defaultItem) => ({
      ...defaultItem,
      icon:
        SIDEBAR_ICONS_FOR_TYPES?.[moduleType]?.[defaultItem?.type] ??
        SIDEBAR_ICONS_FOR_NAMES?.[moduleType]?.[defaultItem?.name] ??
        SIDEBAR_ICONS_FOR_TYPES.defaultList.MY_TEAM,
    }));

    const cohortListWithIcons = cohortList.map((defaultItem) => ({
      ...defaultItem,
      icon: SIDEBAR_ICONS_FOR_TYPES.defaultList.MY_TEAM,
    }));
    return {
      cohortList: cohortListWithIcons,
      defaultList: defaultListWithIcons,
      isShowViewsSection: res?.entity?.isShowViewsSection,
      isIc: res?.entity?.isIc,
      isModuleAdmin: res?.entity?.isModuleAdmin,
    };
  });
};

// export const useSidebarCohort = ({ module }) =>
//   useQuery(
//     [REACT_QUERY_KEYS.sidebarCohorts, module],
//     () => {
//       if (module) {
//         return getData({ moduleType: module });
//       }
//     },
//     {
//       enabled: Boolean(module)
//     }
//   );

export const useSidebarCohortViews = ({ module }) => {
  const enabledFeatures = useSelector(selectEnabledFeatureFlags);

  return useQuery(
    [REACT_QUERY_KEYS.views.sidebarViewCohorts, module],
    () => {
      if (module) {
        return getModuleSidebarNavCohorts({ moduleType: module });
      }
    },
    {
      enabled: Boolean(module) && Boolean(enabledFeatures),
    }
  );
};

export const useSidebarCohortViewsDataInvalidator = () => {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries([REACT_QUERY_KEYS.views.sidebarViewCohorts]);
};
